import React, { useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import { Error404 } from "../../Components/Animation/animation.component";

const PageNotFound = ({ history }) => {
  useEffect(() => {
    document.title = "404 Not Found";
  }, []);
  return (
    <div
      style={{
        display: "flex",
        position: "relative",
        flexDirection: "column",
        alignItems: "center",
        top: 150,
      }}
    >
      <Error404 />
      <h3
        style={{
          textAlign: "center",
          fontSize: "calc(20px + 0.7vw)",
          fontWeight: "600",
          fontFamily: "Montserrat",
          color: "black",
          padding: 10,
        }}
      >
        Oops! Page Not Found ¯\_(ツ)_/¯
      </h3>
      <Link
        style={{ fontFamily: "Montserrat" }}
        onClick={() => history.goBack()}
      >
        Click Here to Redirect
      </Link>
    </div>
  );
};

export default withRouter(PageNotFound);
